// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__4S2lc","footer":"Form_footer__32_Rt"};